module.exports = __webpack_public_path__ + "img/frame_2.28a6a7f.png";